import type { WorkoutCreate, WorkoutList } from 'types';

/** What a workout is being assigned to. Exactly one owner, mirroring the DB constraint. */
export type AssignmentTarget =
  | { kind: 'classType'; id: string; name: string }
  | { kind: 'athlete'; id: string; name: string };

/** The owner fields of a POST /workouts/ body. */
export function assignmentTargetFields(
  target: AssignmentTarget,
): Pick<WorkoutCreate, 'kiloClassType' | 'athlete'> {
  if (target.kind === 'athlete') return { kiloClassType: null, athlete: target.id };

  return { kiloClassType: target.id, athlete: null };
}

/**
 * The `Assigned To` column: the class name for a class workout, or
 * `Athlete - <name>` for one assigned to an individual.
 */
export function assignedToLabel(workout: Pick<WorkoutList, 'kiloClassType' | 'athlete'>): string | null {
  if (workout.kiloClassType) return workout.kiloClassType.name;
  if (workout.athlete) return `Athlete - ${workout.athlete.fullName}`;

  return null;
}
